import React from 'react';
const INK = '#01332b';
const SKIN = '#FBF7F0';
interface FigureProps {
  className?: string;
}
export function FirstbornFigure({
  className = ''
}: FigureProps) {
  return <svg viewBox="0 0 120 148" className={className} role="img" aria-label="Stylised illustration of a neat, composed firstborn" data-id="element-10" data-mp="r81qi46pc4as">
      {/* structured frame — everything in its place */}
      <rect x="12" y="14" width="96" height="112" rx="12" fill="none" stroke="#A1D4FD" strokeWidth="3" data-id="element-11" data-mp="3uo8ihdfr8d3q" />
      <path d="M12 40 h14 M108 40 h-14" stroke="#A1D4FD" strokeWidth="3" strokeLinecap="round" data-id="element-12" data-mp="3ps1ngfowcm0k" />

      {/* arms */}
      <path d="M40 84 v30" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-13" data-mp="3iqko8ahvjps" />
      <path d="M80 84 v30" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-14" data-mp="3ktlzoh3kz9t" />

      {/* legs */}
      <path d="M52 118 v16" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-15" data-mp="1jyjtl57fe5o7" />
      <path d="M68 118 v16" stroke={INK} strokeWidth="7" strokeLinecap="round" data-id="element-16" data-mp="1excgqrqfegao" />

      {/* torso */}
      <rect x="40" y="72" width="40" height="48" rx="14" fill={INK} data-id="element-17" data-mp="uzzxrwi90o9e" />
      <path d="M52 74 l8 9 l8 -9" fill="none" stroke={SKIN} strokeWidth="2.6" strokeLinecap="round" data-id="element-18" data-mp="zvozo6hqqh8v" />
      <circle cx="60" cy="96" r="1.9" fill={SKIN} data-id="element-19" data-mp="18xohh10kxpcv" />
      <circle cx="60" cy="105" r="1.9" fill={SKIN} data-id="element-20" data-mp="18wdgta2fkxpz" />
      <circle cx="60" cy="114" r="1.9" fill={SKIN} data-id="element-21" data-mp="c7e2pef611pv" />

      {/* head */}
      <circle cx="60" cy="52" r="16" fill={SKIN} stroke={INK} strokeWidth="3" data-id="element-22" data-mp="c5b6gcnf6ccp" />
      <path d="M44.5 48 a15.5 15.5 0 0 1 31 0 q-3 -5 -9 -6 q-10 -2 -17 4 q-3 1 -5 2 z" fill={INK} data-id="element-23" data-mp="h70h3r6qco09" />
      <circle cx="54" cy="53" r="2.2" fill={INK} data-id="element-24" data-mp="l5zl99kn0gqn" />
      <circle cx="66" cy="53" r="2.2" fill={INK} data-id="element-25" data-mp="pz2jvw49ugdp" />
      <path d="M55 60 q5 4 10 0" fill="none" stroke={INK} strokeWidth="2.4" strokeLinecap="round" data-id="element-26" data-mp="q0nbpdz7bl7v" />

      {/* tidy ground line */}
      <path d="M30 140 h60" stroke={INK} strokeWidth="3" strokeLinecap="round" data-id="element-27" data-mp="3tm2sje7u83eg" />
    </svg>;
}